import { render, staticRenderFns } from "./viewDialog.vue?vue&type=template&id=017c220a&scoped=true"
import script from "./viewDialog.vue?vue&type=script&lang=js"
export * from "./viewDialog.vue?vue&type=script&lang=js"
import style0 from "./viewDialog.vue?vue&type=style&index=0&id=017c220a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017c220a",
  null
  
)

export default component.exports